import { Form, FormGroup } from "react-bootstrap";
import { SelectCountry } from "../../../../components/SelectCountry/SelectCountry";
import _ from "lodash";
import { Fragment, useCallback } from "react";
import { useSelector } from "react-redux";
import { getAvailableCountries } from "../../../../app/appSelectors";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { getDepositAvailableMethodsLoading, makeSelectPayoutError } from "../../accountSelectors";
import PaymentMethodLogo from "../PaymentMethodLogo/PaymentMethodLogo";
import {
    ChangePaymentSelectMethodButtonsStyled,
    ChangePaymentSelectMethodCheckRowStyled,
    ChangePaymentSelectMethodInfoStyled
} from "./styled/ChangePaymentSelectMethodStyled";
import { Loader } from "../../../../components/Loader/Loader";
import CashierWrapper from "../CashierWrapper/CahiserWrapper";
import classNames from "classnames";

function ChangePaymentSelectMethod(props) {
    const {
        availableMethods,
        isSliderWrapper,
        selectedCountry,
        selectedPayment,
        setOpenedChangePaymentMethod,
        setSelectedCountryHandler,
        setSelectedPaymentHandler,
        show,
    } = props;

    const {getLangPath} = useLangContext();
    const availableCountries = useSelector(getAvailableCountries);
    const depositAvailableMethodsLoading = useSelector(getDepositAvailableMethodsLoading);
    const payoutError = useSelector(makeSelectPayoutError());

    const handleClose = useCallback(() => {
        setOpenedChangePaymentMethod(false);
    }, [setOpenedChangePaymentMethod]);

    return <CashierWrapper title={getLangPath('payment.change_payment_method')}
                           sliderTitle={getLangPath('payment.change_payment_method')} show={show}
                           isSlider={isSliderWrapper} handleClose={handleClose}>
        <div className={'px-3'}>
            <FormGroup className="mt-3 mb-4">
                <Form.Label className={classNames({'color-white-60': isSliderWrapper})}>
                    {getLangPath('payment.country')}
                </Form.Label>
                <SelectCountry
                    availableCountries={availableCountries}
                    onSelect={setSelectedCountryHandler}
                    selectedCountry={selectedCountry}
                />
            </FormGroup>

            {
                !!payoutError && <FormGroup className="mt-3">
                    <div className="text-danger">{getLangPath(payoutError)}</div>
                </FormGroup>
            }

            {
                !!availableMethods.length && <>
                    <Form.Group className="mb-3">
                        <Loader show={depositAvailableMethodsLoading}/>
                        <ChangePaymentSelectMethodButtonsStyled>
                            {
                                _.sortBy(availableMethods, 'pos').map(item => <Fragment key={item.id}>
                                    <ChangePaymentSelectMethodCheckRowStyled onClick={() => {
                                        setSelectedPaymentHandler(item)
                                    }}>
                                        <ChangePaymentSelectMethodInfoStyled>
                                            <PaymentMethodLogo paymentKey={item.key}/>
                                            <span className={'f16'}>{item.label}</span>
                                        </ChangePaymentSelectMethodInfoStyled>
                                        <Form.Check
                                            checked={item.key === selectedPayment?.key}
                                            readOnly
                                            type={'radio'}
                                            name={'payment_method'}
                                            value={item.key}
                                            id={item.key}
                                        />
                                    </ChangePaymentSelectMethodCheckRowStyled>
                                </Fragment>)
                            }
                        </ChangePaymentSelectMethodButtonsStyled>
                    </Form.Group>
                </>
            }

        </div>
    </CashierWrapper>
}

export default ChangePaymentSelectMethod;
